module.exports = __webpack_public_path__ + "static/media/vapi_ex1.b11db76e.png";